module.exports = __webpack_public_path__ + "img/594e617.jpg";